import { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { ReactComponent as ChevronSVG } from "components/assets/vendors/images/chevron.svg";
import { Autoplay, FreeMode, Navigation, Thumbs } from "swiper/modules";

const ProductSlider = ({ images }) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const swiperRefer = useRef(null);

    const goNext = () => {
        if (swiperRefer.current) {
            swiperRefer.current.swiper.slideNext();
        }
    };

    const goPrev = () => {
        if (swiperRefer.current) {
            swiperRefer.current.swiper.slidePrev();
        }
    };
    return (
        <>
            <div className="carousel slide">
                <div className="container px-0">
                    <Swiper
                        spaceBetween={1000}
                        autoplay={{
                            delay: 4500,
                            disableOnInteraction: true,
                        }}
                        thumbs={{ swiper: thumbsSwiper }}
                        pagination={{ type: "fraction" }}
                        modules={[FreeMode, Navigation, Thumbs, Autoplay]}
                        ref={swiperRefer}
                        className="mySwiper2 swiper swiper-preview swiper-preview-details aspect-ratio-1"
                    >
                        {images?.map((item, index) => (
                            <SwiperSlide className="d-flex justify-content-center align-items-center" key={index}>
                                <img
                                    className="img-fluid"
                                    src={item}
                                    alt={index}
                                    style={{ width: "300px", height: "300px" }}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <button
                        type="button"
                        className="carousel-control-prev border-0 btn-carousel-action w-auto"
                        style={{ background: "transparent" }}
                        data-slide="prev"
                        onClick={goPrev}
                    >
                        <ChevronSVG width={30} height={30} style={{ transform: "rotate(-90deg)" }} />
                    </button>
                    <button
                        className="carousel-control-next border-0 btn-carousel-action w-auto"
                        style={{ background: "transparent" }}
                        data-slide="next"
                        onClick={goNext}
                    >
                        <ChevronSVG width={30} height={30} style={{ transform: "rotate(90deg)" }} />
                    </button>
                </div>
            </div>
            <div className="container my-10 px-0 slider-link">
                <Swiper
                    onSwiper={setThumbsSwiper}
                    autoplay={{
                        delay: 4500,
                        disableOnInteraction: true,
                    }}
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs, Autoplay]}
                    className="mySwiper swiper swiper-view mt-1"
                >
                    {images?.map((item, index) => (
                        <SwiperSlide className="h-auto" key={index}>
                            <div
                                className="container text-center p-1 d-flex justify-content-center align-items-center rounded-3 h-100"
                                style={{
                                    border: "1px solid #dee2e6",
                                    borderRadius: "10px",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.border = "1px solid black")}
                                onMouseLeave={(e) => (e.currentTarget.style.border = "1px solid #dee2e6")}
                            >
                                <img
                                    className="rounded"
                                    src={item}
                                    alt={index}
                                    style={{
                                        width: "70px",
                                        height: "auto",
                                        aspectRatio: "1 / 1",
                                        objectFit: "contain",
                                    }}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </>
    );
};

export default ProductSlider;
